function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColteneModernLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.997,
    height: 21.999,
    viewBox: "0 0 159.997 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coltene_modern_logo_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Logo Coltene"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46430",
    d: "M-.328-10.494c0-1.057-.05-1.849-.1-2.762h1.1l.1 2.041h.05a4.173 4.173 0 0 1 3.883-2.305A3.6 3.6 0 0 1 8.162-11h.05a4.612 4.612 0 0 1 1.227-1.561 4.214 4.214 0 0 1 2.88-.961c1.177 0 3.907.625 3.907 5v6.8h-1.178V-8.4c0-2.594-1.052-4.131-3.13-4.131a3.441 3.441 0 0 0-3.155 2.282 3.251 3.251 0 0 0-.225 1.129v7.4H7.36v-7.2c0-2.089-1.052-3.6-2.98-3.6a3.663 3.663 0 0 0-3.331 2.578 3.114 3.114 0 0 0-.2 1.1v7.109H-.328z",
    transform: "translate(.428 18.291)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46431",
    d: "m-4.195 0 3.155 7.723c.326.836.651 1.771.877 2.533h.05c.251-.738.551-1.648.927-2.607L3.744 0h1.277L1.415 8.805c-1.452 3.665-2.479 5.854-4.057 7.206a6.914 6.914 0 0 1-2.1 1.23l-.376-.984a6.048 6.048 0 0 0 2.1-1.328 8.941 8.941 0 0 0 2-2.952 1.676 1.676 0 0 0 .15-.516 1.512 1.512 0 0 0-.15-.516L-5.472 0z",
    transform: "translate(24.079 4.757)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46432",
    d: "M0-3.722a1.031 1.031 0 0 1 1.023-1.107 1.013 1.013 0 0 1 1 1.107A1.044 1.044 0 0 1 1-2.615a1.025 1.025 0 0 1-1-1.107",
    transform: "translate(29.855 19.522)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46433",
    d: "M-42.608-55a10.835 10.835 0 0 1-4.357.738c-5.359 0-8.615-3.3-8.615-8.338 0-5.46 3.856-8.756 9.015-8.756a9.856 9.856 0 0 1 4.107.738l-.676 2.41a8.33 8.33 0 0 0-3.306-.639c-3.431 0-5.91 2.115-5.91 6.1 0 3.64 2.179 5.977 5.885 5.977a8.766 8.766 0 0 0 3.356-.615z",
    transform: "translate(89.312 71.354)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46434",
    d: "M-10.693-29.03c0 3.37 1.728 6.05 4.683 6.05 2.98 0 4.658-2.706 4.658-6.173 0-3.124-1.578-6.075-4.658-6.075-3.055 0-4.683 2.779-4.683 6.2m12.6-.246c0 5.558-3.431 8.731-8.089 8.731-4.758 0-7.763-3.566-7.763-8.436 0-5.091 3.256-8.682 8.014-8.682C-1-37.663 1.9-34 1.9-29.276",
    transform: "translate(61.745 37.663)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46435",
    d: "M0 0h3.08v14.044h6.937v2.533H0z",
    transform: "translate(66.29 .27)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46436",
    d: "M-15.794-8.519H-20.6v-2.533h12.745v2.533h-4.859V5.525h-3.08z",
    transform: "translate(95.225 11.322)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46437",
    d: "M-31.011-31.014h-6.361v4.87h7.112v2.484h-10.192v-16.577h9.817v2.484h-6.737v4.28h6.361z",
    transform: "translate(129.791 40.507)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46438",
    d: "M0-55.743V-72.32h3.506l4.357 7.108a45.264 45.264 0 0 1 2.88 5.558h.05c-.2-2.214-.276-4.353-.276-6.886v-5.78h2.855v16.577h-3.18l-4.408-7.28a57.367 57.367 0 0 1-3.03-5.73l-.075.025c.125 2.14.15 4.329.15 7.059v5.927z",
    transform: "translate(102.225 72.59)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46439",
    d: "M-31.011-31.014h-6.361v4.87h7.112v2.484h-10.192v-16.577h9.817v2.484h-6.737v4.28h6.361z",
    transform: "translate(159.596 40.507)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46440",
    d: "m-11.643 0-3.545 7.335h4.657L-6.989 0z",
    transform: "translate(155.218 9.332)",
    style: {
      fill: "#00b9f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46441",
    d: "m-11.643 0-3.545 7.335h4.657L-6.989 0z",
    transform: "translate(161.102 9.332)",
    style: {
      fill: "#5acbf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46442",
    d: "m-11.643 0-3.545 7.335h4.657L-6.989 0z",
    transform: "translate(166.986 9.332)",
    style: {
      fill: "#abe1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46443",
    d: "m-11.643 0-3.545 7.335h4.657L-6.989 0z",
    transform: "translate(153.404 1.084)",
    style: {
      fill: "#00aeef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46444",
    d: "m-11.643 0-3.545 7.335h4.657L-6.989 0z",
    transform: "translate(159.288 1.084)",
    style: {
      fill: "#00aeef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46445",
    d: "m-11.643 0-3.545 7.335h4.657L-6.989 0z",
    transform: "translate(165.173 1.084)",
    style: {
      fill: "#00aeef"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColteneModernLogoBlack);
export default __webpack_public_path__ + "static/media/coltene_modern_logo_black.711ad7ade334bc280993eed0b6577b51.svg";
export { ForwardRef as ReactComponent };